import { Route, Switch, BrowserRouter } from "react-router-dom";

import DoobiHeader from "components/Headers/DoobiHeader";
import MonthlyPackageSubscribers from "components/Doobi/MonthlyPackageSubscribers";

const MonthlyPackageSubscribersRoute = ({ match }) => {
  return (
    <>
      <DoobiHeader section="Package Subscribers" />
      <BrowserRouter>
        <Switch>
          <Route path={`${match.path}/`} component={MonthlyPackageSubscribers} />
        </Switch>
      </BrowserRouter>
    </>
  );
};

export default MonthlyPackageSubscribersRoute;
